import { CookieConsent } from '../enums';
import { ElementConfig } from '../types';
import { FEED_WIDGET_ELEMENT_NAME } from './pimster-feed-widget.constants';

const pimsterFeedWidgetConfig: ElementConfig = {
  name: FEED_WIDGET_ELEMENT_NAME,
  attributes: [
    {
      name: 'company',
      defaultValue: '',
    },
    {
      name: 'product',
      defaultValue: '',
    },
    {
      name: 'moduleId',
      defaultValue: '',
    },
    {
      name: 'cookieConsent',
      defaultValue: CookieConsent.Ask,
    },
  ],
};

export default pimsterFeedWidgetConfig;
